class escSlider {
    constructor (theme, elem) {
        this._theme = theme
        this._container = this.getContainer(elem)
        this._elem = elem
        this._slides = elem.getElementsByClassName('esc-slide')
        this._imgsToLoad = elem.querySelectorAll('[data-load-bg]')
        this._vidsToLoad = elem.querySelectorAll('[data-load-video]')
        this.easings = this.getEasings()
        this.events = this.createEvents()
        this.settings = this.setSettings(this._elem)
        this.attributes = this.getAttributes(this._elem)
        this.sWidth = this._container.scrollWidth
        this.timerRef = null
        this.touched = false
        this.animateRef = null
        this._loadVideosAbove = 480
        this._videosLoaded = false
    }

    onInit () {
        if (this.settings.initiate) this.init()
    }

    init () {
        if (this._slides.length < this.settings.slideby) {
            return false
        }
        this.arrows = this.settings.arrows ? this.buildArrows() : false
        if (this._slides.length > this.settings.slideby) {
            this.dots = this.settings.dots ? this.buildDots() : false
        }
        this.defaultEvents()
        if (this._vidsToLoad.length > 0) {
            this.setupSlides()
            this._vidsToLoad = this._elem.querySelectorAll('[data-load-video]')
            this.addYouTubeScript(this._vidsToLoad)
        }
        if (this._imgsToLoad.length > 0) {
            this._imgsToLoad = this._elem.querySelectorAll('[data-load-bg]')
            this.loadRelativeImg(this._imgsToLoad)
        }
        if (this._imgsToLoad.length === 0 && this._vidsToLoad.length === 0) {
            this.setupSlides()
            this.initiated()
        }
        return this
    }

    initiated () {
        this.attributes.imgsLoaded = true
        if (this.arrows) {
            this.arrows.elemContainer.classList.add('initiated')
        }
        if (this.dots) {
            this.dots.elemContainer.classList.add('initiated')
        }
        this._elem.classList.add('initiated')
        this._elem.dispatchEvent(this.events.initiated)
        if (this.settings.autoplay) this.start()
    }

    createEvents () {
        let retObj = {}
        retObj.initiated = new Event('initiated')
        retObj.nextSlide = new Event('next-slide')
        retObj.prevSlide = new Event('prev-slide')
        retObj.changeSlide = new Event('change-slide')
        retObj.beforeSlide = new Event('before-slide')
        retObj.afterSlide = new Event('after-slide')
        return retObj
    }

    buildDots () {
        let dots = {}
        dots.elemContainer = document.createElement('ul')
        dots.elemContainer.classList.add('esc-slider-dots')
        dots.elemDots = []
        let buildAmount = this._slides.length / this.settings.slideby
        for (let i = 0; i < buildAmount; i++) {
            let elemTempItem = document.createElement('li')
            if (i === 0) elemTempItem.classList.add('active')
            elemTempItem.classList.add('dot', `dot-${i}`, `slide-${i}`)
            elemTempItem.addEventListener('click', e => this.manageDot(i))
            let elemTempSpan = document.createElement('span')
            elemTempSpan.innerHTML = `Slide ${i + 1}`
            elemTempItem.appendChild(elemTempSpan)
            dots.elemDots.push(elemTempItem)
            dots.elemContainer.appendChild(elemTempItem)
        }
        dots.active = dots.elemDots[0]
        this.attributes.max = dots.elemDots.length - 1
        this._container.appendChild(dots.elemContainer)
        return dots
    }

    manageDot (i) {
        this.goToSlide(i)
    }

    buildArrows () {
        let arrows = {}
        arrows.elemContainer = document.createElement('div')
        arrows.elemContainer.classList.add('esc-slider-arrows')
        arrows.elemArrowLeft = document.createElement('div')
        arrows.elemArrowLeft.classList.add('arrow', 'arrow-left')
        arrows.elemArrowLeft.innerHTML = 'Previous'
        arrows.elemArrowRight = document.createElement('div')
        arrows.elemArrowRight.classList.add('arrow', 'arrow-right')
        arrows.elemArrowRight.innerHTML = 'Next'
        arrows.elemContainer.appendChild(arrows.elemArrowLeft)
        arrows.elemContainer.appendChild(arrows.elemArrowRight)
        arrows.elemArrowRight.addEventListener('click', e => {
            this.goToNext()
        })
        arrows.elemArrowLeft.addEventListener('click', e => {
            this.goToPrev()
        })
        this._container.appendChild(arrows.elemContainer)
        return arrows
    }

    loadRelativeImg (imgElems) {
        let loadCount = 0
        for (let elem of imgElems) {
            let indCount = 0
            let bgImg = ''
            let imgSplit = elem.dataset.loadBg.split('|')
            for (var i = 0; i < imgSplit.length; i++) {
                this.getImg(imgSplit[i]).then(url => {
                    indCount++
                    bgImg += `url("${url}"),`
                    if (indCount === imgSplit.length) {
                        bgImg = bgImg.slice(0, -1)
                        elem.style.backgroundImage = bgImg
                        loadCount++
                    }
                }).then(() => {
                    this.attributes.allImgsLoaded = loadCount === imgElems.length
                    if (loadCount === imgElems.length && this._vidsToLoad.length === 0) {
                        this.setupSlides()
                        this.initiated()
                    }
                })
            }
        }
        return false
    }

    videoResizeCheck (vidElems, firstRun) {
        if (window.innerWidth > this._loadVideosAbove && !this._videosLoaded) {
            let loadCount = 0
            let lookFor = '?v='
            for (let vElem of vidElems) {
                let videoId = vElem.dataset.loadVideo
                let tempPlayer = new window.YT.Player(vElem, {
                    height: '1920',
                    width: '1080',
                    videoId: videoId.substr(videoId.indexOf(lookFor) + lookFor.length, videoId.length),
                    events: {
                        'onReady': evt => {
                            loadCount++
                            this.onVideoReady(evt, loadCount)
                        },
                        'onStateChange': evt => {
                            this.onVideoStateChange(evt)
                        }
                    },
                    playerVars: {
                        'autoplay': 0,
                        'controls': 0,
                        'enablejsapi': 1,
                        'showinfo': 0,
                        'playsinline': 1,
                        'rel': 0,
                        'modestbranding': 1,
                        'fs': 0,
                        'always_fs': 0
                    }
                })
                console.dir(tempPlayer)
                this.video.all.push(tempPlayer)
                this.video.ref[tempPlayer.a.id] = tempPlayer
            }
            this.addVideoData(this.video.all)
            this._videosLoaded = true
        } else if (firstRun) {
            this.initiated()
        }
    }

    addYouTubeScript (vidElems) {
        this.video = {}
        this.video.currentlyPlaying = false
        this.video.all = []
        this.video.ref = {}
        document.addEventListener('youtube-api-ready', e => {
            window.addEventListener('resize', e => {
                this.videoResizeCheck(vidElems, false)
            })
            this.videoResizeCheck(vidElems, true)
        })
        window.onYouTubeIframeAPIReady = () => {
            if (this.attributes.videoScript.loaded) return false
            document.dispatchEvent(new Event('youtube-api-ready'))
            this.attributes.videoScript.loaded = true
        }
        this.attributes.videoScript = document.createElement('script')
        this.attributes.videoScript.type = 'text/javascript'
        this.attributes.videoScript.src = 'https://www.youtube.com/iframe_api'
        let firstScriptTag = document.getElementsByTagName('script')[0]
        firstScriptTag.parentNode.insertBefore(this.attributes.videoScript, firstScriptTag)
    }

    addVideoData (allPlayers) {
        for (let player of allPlayers) {
            let lookIn = player.a
            let foundElem = false
            while (!foundElem) {
                if (lookIn.classList.contains('esc-slide')) {
                    foundElem = lookIn
                }
                lookIn = lookIn.parentNode
            }
            foundElem.dataset.videoPlayer = player.a.id
        }
    }

    onVideoStateChange (evt) {
        let ytStates = window.YT.PlayerState
        if (this.attributes.moving && evt.data === ytStates.PLAYING) {
            evt.target.stopVideo()
            return false
        } else if (evt.data === ytStates.PLAYING) {
            this.video.currentlyPlaying = evt.target
            if (this.settings.autoplay) this.stop()
        } else if (evt.data === ytStates.PAUSED || evt.data === ytStates.ENDED) {
            this.video.currentlyPlaying = null
            if (this.settings.autoplay && !this.attributes.wasStopped) this.start()
        }
    }

    onVideoReady (evt, loadCount) {
        if (loadCount !== this._vidsToLoad.length) return false
        this.activeSlide = this._slides[this.attributes.activeSlide]
        this.initiated()
    }

    getImg (url) {
        return new Promise((resolve, reject) => {
            let img = new Image()
            img.onload = () => {
                resolve(url)
            }
            img.onerror = () => {
                reject(url)
            }
            img.src = url
        })
    }

    touchStart (evt) {
        if (this.activeSlide.dataset.sliderIgnoreSwipe === '' || this.attributes.moving) return false
        this._elem.classList.add('dragging')
        this.touched = {
            oldCurrX: this.attributes.currX,
            oldTouchX: evt.touches[0].clientX,
            movedBy: 0,
            fullyMovedBy: 0,
            newTouchX: evt.touches[0].clientX,
            target: evt.target,
            startY: evt.touches[0].clientY
        }
    }

    touchMove (evt) {
        if (this.activeSlide.dataset.sliderIgnoreSwipe === '' || this.attributes.moving || !this.touched) return false
        this.touched.currY = evt.touches[0].clientY
        this.touched.newTouchX = evt.touches[0].clientX
        let verticalSwipeLength = Math.round(Math.sqrt(Math.pow(this.touched.currY - this.touched.startY, 2)))
        if (verticalSwipeLength > 4) {
            return false
        }
        evt.preventDefault()
        this.touched.movedBy = this.touched.oldTouchX - this.touched.newTouchX
        this.touched.fullyMovedBy += this.touched.movedBy
        this.touched.oldTouchX = evt.touches[0].clientX
        this.attributes.currX = this.attributes.currX + this.touched.movedBy
        this.transform(this.attributes.currX)
    }

    touchEnd (evt) {
        if (this.activeSlide.dataset.sliderIgnoreSwipe === '' || this.attributes.moving) return false
        let diff = this.attributes.currX - this.touched.oldCurrX
        this.touched.fullyMovedBy = Math.abs(this.touched.fullyMovedBy)
        if (diff > 5) {
            this.goToNext()
        } else if (diff < -5) {
            this.goToPrev()
        } else {
            if (this.touched.movedBy > 10 && this.touched.target && this.touched.target.localName === 'a') {
                window.location.href = this.touched.target.href
            }
        }
        this._elem.classList.remove('dragging')
        this.touched = false
    }

    defaultEvents () {
        window.addEventListener('resize', e => {
            this.attributes.width = this._elem.offsetWidth
            this.attributes.initX = (this.attributes.amountOfSlides / this.settings.slidesperview) * this._elem.offsetWidth
            this.attributes.currX = this.attributes.initX
            this.transform(this.attributes.initX)
        })
        this._elem.addEventListener('mousemove', () => {
            if (this.attributes.moving || !this.settings.autoplay || (this.video && this.video.currentlyPlaying) || this.attributes.wasStopped) return false
            this.stop()
        })
        this._elem.addEventListener('mouseout', () => {
            if (this.attributes.moving || !this.settings.autoplay || (this.video && this.video.currentlyPlaying) || this.attributes.wasStopped) return false
            this.start()
        })

        let allElems = this._elem.querySelectorAll('*')

        for (let elem of allElems) {
            elem.addEventListener('touchstart', e => {
                this.touchStart(e)
            })

            elem.addEventListener('touchmove', e => {
                this.touchMove(e)
            })
        }

        this._elem.addEventListener('touchstart', e => {
            this.touchStart(e)
        })

        this._elem.addEventListener('touchmove', e => {
            this.touchMove(e)
        })

        this._elem.addEventListener('touchend', e => {
            this.touchEnd(e)
        })

        this._container.addEventListener('touchstart', e => {
            this.touchStart(e)
        })

        this._container.addEventListener('touchmove', e => {
            this.touchMove(e)
        })

        this._container.addEventListener('touchend', e => {
            this.touchEnd(e)
        })
    }

    setupSlides () {
        if (this.settings.thumbnails) {
            this.thumbnails = this.settings.thumbnails.children ? this.thumbnailLogic() : this.buildThumbnails()
        }

        let firstLoop = true
        let retArr = []

        for (let i = 0; i < this._slides.length; i++) {
            let currElem = this._slides[i]
            if (firstLoop) currElem.classList.add(`slide-${i}`)
            let clonedNode = currElem.cloneNode(true)
            retArr.push(clonedNode)
            if (i === (this._slides.length - 1) && firstLoop) {
                firstLoop = false
                i = -1
            }
        }

        for (let i = 0; i < retArr.length; i++) {
            let currElem = retArr[i]
            this._elem.appendChild(currElem)
        }

        this.activeSlide = this._slides[this.attributes.activeSlide]
        this.activeSlide.classList.add('active')
        this.transform(this.attributes.initX)
        this.attributes.currX = this.attributes.initX
        return retArr
    }

    thumbnailLogic () {
        let thumbnails = {}
        let elemSlideThumbs = document.querySelectorAll('[data-slide-thumb]')
        thumbnails.all = []
        thumbnails.ref = {}
        for (let i = 0; i < elemSlideThumbs.length; i++) {
            let elemThumbnail = elemSlideThumbs[i]
            thumbnails.ref[`slide-${i}`] = elemThumbnail
            thumbnails.all.push(elemThumbnail)
            elemThumbnail.addEventListener('click', e => this.goToSlide(i))
        }
        thumbnails.active = thumbnails.all[0]
        thumbnails.active.classList.add('active')
        return thumbnails
    }

    buildThumbnails () {
        let thumbnails = {}
        thumbnails.all = []
        thumbnails.ref = {}
        thumbnails.elem = document.createElement('ul')
        thumbnails.elem.classList.add('esc-slider-thumbnails')
        for (let i = 0; i < this._slides.length; i++) {
            let elemThumbnail = this._slides[i].querySelector('[data-slider-thumb]')
            let tempElem = document.createElement('li')
            if (elemThumbnail) {
                tempElem.style.backgroundImage = `url(${elemThumbnail.src})`
            }
            tempElem.addEventListener('click', e => this.manageThumb(i))
            thumbnails.elem.appendChild(tempElem)
            thumbnails.all.push(tempElem)
            thumbnails.ref[`slide-${i}`] = tempElem
        }
        thumbnails.active = thumbnails.all[0]
        thumbnails.active.classList.add('active')
        this._container.appendChild(thumbnails.elem)
        return thumbnails
    }

    manageThumb (i) {
        this.goToSlide(i)
    }

    animate (direction, moveBy) {
        this.animateRef = requestAnimationFrame(ts => this.animate(direction, moveBy))
        this.attributes.oldX = this.attributes.newX
        this.attributes.frameCount++
        this.attributes.calcX = this.easings[this.settings.easing](this.attributes.frameCount, 0, this.attributes.endPoint, this.settings.duration)
        this.attributes.newX = this.attributes.calcX
        let diff = Math.abs(this.attributes.newX - this.attributes.oldX)
        this.attributes.currX = direction === 'prev' ? this.attributes.currX - diff : this.attributes.currX + diff
        this.transform(Math.abs(this.attributes.currX))
        if (this.attributes.calcX === this.attributes.endPoint) {
            this.transform(this.attributes.initX)
            this.attributes.oldX = 0
            this.attributes.newX = 0
            this.attributes.frameCount = -1
            for (var i = 0; i < Math.abs(moveBy * this.settings.slideby); i++) {
                this.attributes.moving = this.cloneSlide(direction)
            }
            this.stop(direction, moveBy)
            if (this.settings.autoplay) this.wait()
        }
    }

    wait (timestamp, oldTime) {
        if (!timestamp) {
            return requestAnimationFrame(timestamp => this.wait(timestamp))
        }
        oldTime = oldTime || timestamp
        let timePassed = timestamp - oldTime
        if (timePassed > (this.settings.interval * 1000)) {
            this.goToNext()
            return false
        }
        this.timerRef = requestAnimationFrame(timestamp => this.wait(timestamp, oldTime))
    }

    cloneSlide (direction) {
        let indexToRemove = direction === 'prev' ? this._slides.length - 1 : 0
        let elemTemp = this._slides[indexToRemove].cloneNode(true)
        this._elem.removeChild(this._slides[indexToRemove])
        // let elemTemp = this._elem.removeChild(this._slides[indexToRemove])
        this.attributes.currX = direction === 'prev' ? this.attributes.currX + (this.attributes.width / this.settings.slidesperview) : this.attributes.currX - (this.attributes.width / this.settings.slidesperview)
        this.transform(this.attributes.currX)
        if (direction === 'prev') {
            this._elem.insertBefore(elemTemp, this._slides[0])
            return false
        }
        if (elemTemp.dataset.loadVideo !== undefined && elemTemp.dataset.loadVideo.length > 0) {
            this._reinitVideo(elemTemp)
        }
        this._elem.appendChild(elemTemp)
        return false
    }

    _reinitVideo (vidElem) {
        let videoId = vidElem.dataset.loadVideo
        let lookFor = '?v='
        this.video.ref[vidElem.dataset.videoPlayer] = new window.YT.Player(vidElem, {
            height: '1920',
            width: '1080',
            videoId: videoId.substr(videoId.indexOf(lookFor) + lookFor.length, videoId.length),
            events: {
                'onStateChange': evt => {
                    this.onVideoStateChange(evt)
                }
            },
            playerVars: {
                'autoplay': 0,
                'controls': 0,
                'enablejsapi': 1,
                'showinfo': 0,
                'playsinline': 1,
                'rel': 0,
                'modestbranding': 1,
                'fs': 0,
                'always_fs': 0
            }
        })
    }

    beforeSlide (direction, moveBy) {
        this._elem.dispatchEvent(this.events.beforeSlide)
        this.attributes.started = true
        this.attributes.moving = true
        this.attributes.endPoint = ((this.attributes.width / this.settings.slidesperview) * moveBy) * this.settings.slideby

        if (this.touched) {
            this.attributes.endPoint -= this.touched.fullyMovedBy
        }

        if (this.dots) {
            let newIndex = this.dots.elemDots.indexOf(this.dots.active)
            newIndex = direction === 'prev' ? newIndex - Math.abs(moveBy) : newIndex + moveBy
            newIndex = newIndex < 0 ? this.dots.elemDots.length - 1 : newIndex
            newIndex = newIndex > this.dots.elemDots.length - 1 ? 0 : newIndex
            this.dots.active.classList.remove('active')
            this.dots.active = this.dots.elemDots[newIndex]
            this.dots.active.classList.add('active')
        }

        if (this.thumbnails) {
            let newIndex = this.thumbnails.all.indexOf(this.thumbnails.active)
            newIndex = direction === 'prev' ? newIndex - Math.abs(moveBy) : newIndex + moveBy
            newIndex = newIndex < 0 ? this.thumbnails.all.length - 1 : newIndex
            newIndex = newIndex > this.thumbnails.all.length - 1 ? 0 : newIndex
            this.thumbnails.active.classList.remove('active')
            this.thumbnails.active = this.thumbnails.all[newIndex]
            this.thumbnails.active.classList.add('active')
        }

        this.animate(direction, moveBy)
    }

    afterSlide (direction, moveBy) {
        this.attributes.started = false
        this.activeSlide.classList.remove('active')
        this.activeSlide = this._slides[this.attributes.activeSlide]
        this.activeSlide.classList.add('active')

        this.attributes.activeIndex = direction === 'prev' ? this.attributes.activeIndex - Math.abs(moveBy) : this.attributes.activeIndex + moveBy
        this.attributes.activeIndex = this.attributes.activeIndex < 0 ? this.attributes.max : this.attributes.activeIndex > this.attributes.max ? 0 : this.attributes.activeIndex

        if (this.sWidth !== this._container.scrollWidth) {
            this.sWidth = this._container.scrollWidth
            this.arrangeSlides()
        }

        this._elem.dispatchEvent(this.events.afterSlide)
    }

    arrangeSlides () {
        this.attributes.width = this._elem.offsetWidth
        this.attributes.width = this._elem.offsetWidth
        this.attributes.initX = (this.attributes.amountOfSlides / this.settings.slidesperview) * this._elem.offsetWidth
        this.attributes.currX = this.attributes.initX
        this.transform(this.attributes.initX)
    }

    goToPrev () {
        if (this.attributes.started || this.attributes.moving) return false
        this.beforeSlide('prev', 1)
    }

    goToNext () {
        if (this.attributes.started || this.attributes.moving) return false
        this.beforeSlide('next', 1)
    }

    goToSlide (slideNum) {
        if (slideNum === this.attributes.activeIndex || this.attributes.started || this.attributes.moving) return false
        let moveBy = (slideNum - this.attributes.activeIndex)
        let direction = slideNum < this.attributes.activeIndex ? 'prev' : 'next'
        this.beforeSlide(direction, moveBy)
    }

    start () {
        this.attributes.wasStopped = false
        this.wait()
    }

    stop (direction, moveBy) {
        cancelAnimationFrame(this.timerRef)
        if (!this.attributes.started || this.attributes.moving) return false
        this.afterSlide(direction, moveBy)
        cancelAnimationFrame(this.animateRef)
    }

    transform (val) {
        this._elem.style.webkitTransform = `translate3d(-${val}px, 0, 0)`
        this._elem.style.MozTransform = `translate3d(-${val}px, 0, 0)`
        this._elem.style.msTransform = `translate3d(-${val}px, 0, 0)`
        this._elem.style.OTransform = `translate3d(-${val}px, 0, 0)`
        this._elem.style.transform = `translate3d(-${val}px, 0, 0)`
    }

    getEasings () {
        let retObj = {}

        retObj.easeInOutQuad = (time, startingValue, changeInValue, duration) => {
            if ((time /= duration / 2) < 1) return changeInValue / 2 * time * time + startingValue
            return -changeInValue / 2 * ((--time) * (time - 2) - 1) + startingValue
        }

        retObj.easeOutQuad = (time, startingValue, changeInValue, duration) => {
            return -changeInValue * (time /= duration) * (time - 2) + startingValue
        }

        return retObj
    }

    getAttributes (elem) {
        let retObj = {}

        retObj.amountOfSlides = this._slides.length

        retObj.activeIndex = 0
        retObj.activeSlide = retObj.amountOfSlides
        retObj.newIndex = 0

        retObj.calcX = 0
        retObj.currX = 0
        retObj.endPoint = 0
        retObj.initX = retObj.amountOfSlides * (this._elem.offsetWidth / this.settings.slidesperview)
        retObj.oldX = 0
        retObj.oldWidth = window.innerWidth
        retObj.newX = 0

        retObj.currY = 0
        retObj.startY = 0

        retObj.min = 0
        retObj.max = this._slides.length - 1

        retObj.started = false
        retObj.moving = false

        retObj.frameCount = -1

        retObj.height = this._elem.offsetHeight
        retObj.width = this._elem.offsetWidth

        retObj.wasStopped = false

        return retObj
    }

    setSettings (elem) {
        let retObj = {}

        retObj.arrows = true
        retObj.easing = 'easeInOutQuad'
        retObj.dots = true
        retObj.slideby = 1
        retObj.slidesperview = 1
        retObj.speed = 5
        retObj.thumbnails = this._container.querySelector('[data-slider-thumbnails]') || false
        retObj.thumbnails = retObj.thumbnails ? retObj.thumbnails : this._elem.dataset.sliderThumbnailContainer ? this._elem.dataset.sliderThumbnailContainer : false
        retObj.breakpoints = {
            'mobile': {}
        }

        for (let index in elem.dataset) {
            let newIndex = index.toLowerCase()
            if (newIndex.indexOf('slidersetting') === -1) continue
            newIndex = newIndex.replace('slidersetting', '')
            if (newIndex === 'escslider') {
                continue
            }
            let newValue = parseFloat(elem.dataset[index])
            if (isNaN(newValue)) {
                newValue = elem.dataset[index]
            }
            newValue = newValue === 'true' ? true : newValue === 'false' ? false : newValue
            retObj[newIndex] = newValue
        }

        for (let index in elem.dataset) {
            let newIndex = index.toLowerCase()
            if (newIndex.indexOf('sliderbreakpoint') === -1) continue
            for (let idx in retObj.breakpoints) {
                if (newIndex.indexOf(idx) === -1) continue
                newIndex = newIndex.substr(newIndex.indexOf(idx) + idx.length)
                newIndex = newIndex === '' ? 'width' : newIndex
                let newValue = elem.dataset[index]
                newValue = parseFloat(newValue)
                if (isNaN(newValue)) {
                    newValue = elem.dataset[index]
                }
                retObj.breakpoints[idx][newIndex] = newValue
            }
        }

        for (let index in retObj.breakpoints) {
            for (let idx in retObj.breakpoints[index]) {
                if (retObj.breakpoints[index].width < window.innerWidth) break
                if (idx === 'width') continue
                retObj[idx] = retObj.breakpoints[index][idx]
            }
        }

        if (retObj.thumbnails.length > 0) {
            let foundElem = false
            let lookIn = this._container.parentElement
            while (!foundElem) {
                let lookInner = lookIn.querySelector(`[data-${retObj.thumbnails}]`)
                if (lookInner) {
                    retObj.thumbnails = lookInner
                    foundElem = true
                }
                lookIn = lookIn.parentElement
            }
        }

        retObj.fps = 60

        retObj.duration = retObj.fps * retObj.speed

        return retObj
    }

    getContainer (elem) {
        let retElem = this._elem

        retElem = elem.dataset.sliderUseParentContainer && elem.dataset.sliderUseParentContainer.length === 0 ? elem.parentElement : elem

        if (elem.dataset.sliderUseParentContainer && elem.dataset.sliderUseParentContainer.length > 0) {
            let foundElem = false
            let lookIn = elem.dataset.sliderUseParentContainer[0] === '#' ? 'id' : 'className'
            let lookFor = elem.dataset.sliderUseParentContainer.substring(1)
            while (!foundElem) {
                retElem = retElem.parentElement
                if (retElem[lookIn].indexOf(lookFor) !== -1) foundElem = true
            }
        }

        return retElem
    }
}

export default escSlider



// WEBPACK FOOTER //
// ./src/scripts/components/Slider.js